import { useQueryClient } from '@tanstack/vue-query';
import type { RouteRecordRaw } from 'vue-router';

import { resolveCurrentTeam } from '@/entities/team';
import TeamSetupLayout from '@/layouts/team-setup.vue';
import { IS_BILLING_ENABLED } from '@/shared/config';
import { useTeamCookie } from '@/shared/hooks/use-team-cookie';

const billingReadyGuard = async () => {
  const queryClient = useQueryClient();
  const { currentTeamUuid } = useTeamCookie();

  if (!currentTeamUuid.value) {
    return { name: 'team/new' };
  }

  const team = await resolveCurrentTeam(queryClient, currentTeamUuid.value);

  if (!team) {
    return { name: 'team/new' };
  }

  if (team.is_billing_ready) {
    return { name: 'project', params: { project_uuid: 'default' } };
  }
};

const requireCurrentTeamGuard = () => {
  const { currentTeamUuid } = useTeamCookie();

  if (!currentTeamUuid.value) {
    return { name: 'team/new' };
  }
};

const children: RouteRecordRaw[] = [
  {
    path: 'new',
    name: 'team/new',
    component: () => import('@/views/team-setup/new.vue'),
  },
  {
    path: 'invite',
    name: 'team/invite',
    component: () => import('@/views/team-setup/invite.vue'),
    beforeEnter: requireCurrentTeamGuard,
  },
];

if (IS_BILLING_ENABLED) {
  children.splice(1, 0, {
    path: 'billing',
    name: 'team/billing',
    component: () => import('@/views/team-setup/billing.vue'),
    beforeEnter: billingReadyGuard,
  });
}

export default {
  meta: { profile: true },
  path: '/teams',
  component: TeamSetupLayout,
  children,
} satisfies RouteRecordRaw;
